import styled from "styled-components";

export const ButtonsWrapper = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 400;
  display: flex;  
  flex-direction: column;  
`